/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-17T17:39:58.442
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'report-reportmonthrentcontractundue-'

export default 
{
path: '/report/reportmonthrentcontractundue',
name: 'report-reportmonthrentcontractundue',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}reportmonthrentcontractundue-index',

meta:{
...meta,
title: '未到期有效合同报表(定时生成)'
},

component: () => import('@/pages/report/reportmonthrentcontractundue/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}reportmonthrentcontractundue-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '未到期有效合同报表(定时生成)编辑'
},

component: () => import('@/pages/report/reportmonthrentcontractundue/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}reportmonthrentcontractunduedetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '未到期有效合同报表(定时生成)新增'
},

component: () => import('@/pages/report/reportmonthrentcontractundue/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}reportmonthrentcontractundueView',
auth: [
'hidden'
],

meta:{
...meta,
title: '未到期有效合同报表(定时生成)详情查看'
},

component: () => import('@/pages/report/reportmonthrentcontractundue/detail-view') ,
},
]
};
